// extracted by mini-css-extract-plugin
export default {"import":"FullPrivacy_import__VeBiM","importButton":"FullPrivacy_importButton__ygMNR","alert":"FullPrivacy_alert__nkE+U","noalert":"FullPrivacy_noalert__4UfLN"};